import * as React from 'react';

import { cn } from '@/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex w-full min-w-0 resize-none rounded-md border border-transparent bg-neutral-50 px-2 py-1.5 transition-all outline-none focus-visible:border-indigo-500 disabled:pointer-events-none disabled:cursor-not-allowed',
        "font-['Inter'] text-xs leading-none font-medium !text-neutral-900",
        "placeholder:font-['Inter'] placeholder:text-xs placeholder:leading-4 placeholder:font-medium placeholder:text-neutral-500",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
